<template>
    <div>
        <!-- Help de Exame (Klis) -->
        <div class="modal fade" :id="'helpExameModal' + chave" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-xl modal-dialog-scrollable" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">
                            {{ ( dados && dados.help && dados.help.nome ) ? dados.help.nome : 'Informações do Procedimento' }}
                        </h5>
                        <button type="button" class="close" @click="fechar()" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div v-if="dados && dados.help && dados.help.id">
                            <table class="table table-hover">
                                <thead v-if="false">
                                    <tr>
                                        <th colspan="2">{{ dados.help.nome }}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-if="dados.help.bancada">
                                        <td>Bancada</td>
                                        <td>{{ dados.help.bancada }}</td>
                                    </tr>
                                    <tr v-if="dados.help.acondicionamento">
                                        <td>Acondicionamento</td>
                                        <td>{{ dados.help.acondicionamento }}</td>
                                    </tr>
                                    <tr>
                                        <td>Materiais</td>
                                        <td>
                                            <ul class="list-group" v-if="dados.help.materiais && dados.help.materiais.length > 1">
                                                <li class="list-group-item p-2" v-for="(material, imx) in dados.help.materiais" :key="imx">
                                                    {{ material.nome }} 
                                                    <span v-if="material.volume" class="small text-muted ml-3">Volume: {{ material.volume }} ml</span>
                                                </li>
                                            </ul>
                                            <span v-else-if="dados.help.materiais && dados.help.materiais.length === 1">
                                                {{ dados.help.materiais[0].nome }}
                                                <span v-if="dados.help.materiais[0].volume" class="small text-muted ml-3">Volume: {{ dados.help.materiais[0].volume }} ml</span>
                                            </span>
                                        </td>
                                    </tr>
                                    <tr v-if="dados.help.metodo">
                                        <td>Metodologia</td>
                                        <td>
                                            {{ dados.help.metodo }}
                                        </td>
                                    </tr>
                                    <tr v-if="dados.help.apoio">
                                        <td>Apoio</td>
                                        <td>
                                            {{ dados.help.apoio }}
                                        </td>
                                    </tr>
                                    <tr v-if="dados.help.equipamentos && dados.help.equipamentos.length">
                                        <td>Aparelhos</td>
                                        <td>
                                            <ul class="list-group" v-if="dados.help.equipamentos && dados.help.equipamentos.length > 1">
                                                <li class="list-group-item p-2" v-for="(equip, imx) in dados.help.equipamentos" :key="imx">
                                                    {{ equip.nome }}
                                                </li>
                                            </ul>
                                            <span v-else-if="dados.help.equipamentos && dados.help.equipamentos.length === 1">
                                                {{ dados.help.equipamentos[0].nome }}
                                            </span>
                                        </td>
                                    </tr>
                                    <tr v-if="dados.help.preparos && dados.help.preparos.length">
                                        <td>Preparos</td>
                                        <td>
                                            <ul class="list-group">
                                                <li class="list-group-item p-2" v-for="(preparo, imx) in dados.help.preparos" :key="imx">
                                                    {{ preparo }}
                                                </li>
                                            </ul>
                                        </td>
                                    </tr>
                                    <tr v-if="dados.help.prazos && dados.help.prazos.length">
                                        <td>Prazos</td>
                                        <td>
                                            <ul class="list-group">
                                                <li class="list-group-item p-2" v-for="(prazo, imx) in dados.help.prazos" :key="imx">
                                                    <span>{{ prazo.prazo }}{{ prazo.medida }}</span>
                                                    <span class="badge badge-danger ml-2" v-if="prazo.urgente">Urgente</span>
                                                    <span class="badge badge-secondary ml-2" v-if="prazo.local">{{ prazo.local.nome }}</span>
                                                    <span class="badge badge-secondary ml-2" v-if="prazo.unidade_apoio">{{ prazo.unidade_apoio.nome }}</span>
                                                    <span class="badge badge-secondary ml-2" v-if="prazo.apoiado">{{ prazo.apoiado.nome }}</span>
                                                </li>
                                            </ul>
                                        </td>
                                    </tr>
                                    <tr v-if="dados.help.instrucao_operador">
                                        <td>Instrução Interna</td>
                                        <td>
                                            <span v-html="dados.help.instrucao_operador"></span>
                                        </td>
                                    </tr>
                                    <tr v-if="dados.help.instrucao_paciente">
                                        <td>Instrução Paciente</td>
                                        <td>
                                            <span v-html="dados.help.instrucao_paciente"></span>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" @click="fechar()">Fechar</button>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
import $ from 'jquery';

export default {
    data() {
        return { 
            dados: null, 
            chave: ""
        };
    },

    methods: { 
        fechar() { 
            $("#helpExameModal" + this.chave).modal('hide');
        },      

        abrir_procedimento(id_procedimento) { 

            this.dados = null; 

            $("#helpExameModal" + this.chave).modal('show');

            this.$util.load(this, { 
                service: 'laudos', 
                func: 'help_exame_klis', 
                parms: { 
                    id_procedimento: id_procedimento, 
                },
                loadTo: res => { 
                    this.dados = res;
                }
            });

        }

    },

    beforeMount() { 
        this.chave = this.$util.uuidv4(); 
    }

}
</script>
